import { STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { DataType } from '@inpart-io/padme-iap';
import { type IDealType, type IDirectoryAsset, type IPrivateAsset, privateAssetsManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { DIRECTORY_ASSET_MODULE } from '@/store/directory-asset-module';

export const SEARCH_ALL_BY_COMPANY = 'searchAllByCompany';

export const actions: ActionTree<IDealType, unknown> = {
    async [SEARCH_ALL_BY_COMPANY](
        context,
        {
            companyId,
            directoryCompanyId,
            startIndex,
            maxResults,
            properties
        }: { companyId: number; directoryCompanyId: number; startIndex?: number; maxResults?: number; properties?: string }
    ): Promise<{ privateIdList: number[]; directoryIdList: number[] }> {
        const privateIdList: number[] = [];
        const directoryIdList: number[] = [];
        const privateList: IPrivateAsset[] = [];
        const directoryList: IDirectoryAsset[] = [];

        const result = await privateAssetsManager.allByCompany(companyId, directoryCompanyId, startIndex, maxResults, { properties });

        result.forEach((asset: IPrivateAsset | IDirectoryAsset) => {
            if (asset['@type'] === DataType.DirectoryAsset) {
                directoryList.push(asset);
                directoryIdList.push(asset.dobjId);
            } else {
                privateList.push(asset);
                privateIdList.push(asset.dobjId);
            }
        });
        await context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: privateList });
        await context.dispatch(`${DIRECTORY_ASSET_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: directoryList }, { root: true });

        return { privateIdList, directoryIdList };
    }
};
